import {css} from 'styled-components';


const fontFamilySF = 'SF, sans-serif';


export const typeSF32b = css`
  font-family: ${fontFamilySF};
  font-size: 32px;
  line-height: 50px;
  font-weight: bold;
`;

export const typeSF18r = css`
  font-family: ${fontFamilySF};
  font-size: 18px;
  line-height: 30px;
`;

export const typeSF18b = css`
  font-family: ${fontFamilySF};
  font-size: 18px;
  line-height: 30px;
  font-weight: bold;
`;




// WEBPACK FOOTER //
// ./src/styles/typefaces.js